// extracted by mini-css-extract-plugin
export var notificationHost = "_kg-0";